import { useContext } from 'react';
import { LanguageContext, LanguageContextValue } from '../contexts/Language';

const useLanguageContext = (): LanguageContextValue =>
  useContext(LanguageContext);

export default useLanguageContext;
